import { Star } from "lucide-react"
import { useTranslation } from "react-i18next"

import { Badge } from "@f2e/ui/components/base"

import { AgentHistory } from "@/types"

export interface AgentHistoryDetailedItemProps {
  history: AgentHistory
  isCurrent: boolean
}

export const AgentHistoryDetailedItem = ({
  history,
  isCurrent,
}: AgentHistoryDetailedItemProps) => {
  const { t, i18n } = useTranslation()

  return (
    <div className="flex flex-col w-full gap-1">
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-1">
            <span className="text-sm font-medium">
              {t("workspace.agent.history.ui.versionNumber", {
                number: history.versionNumber,
              })}
            </span>
            {history.wasPublished && (
              <Star className="h-3 w-3 text-yellow-500 fill-current" />
            )}
          </div>
          {isCurrent && (
            <Badge variant="secondary" className="text-xs">
              {t("workspace.agent.current")}
            </Badge>
          )}
        </div>
        <div className="text-xs text-muted-foreground text-right shrink-0">
          <div>
            {new Date(history.createdAt).toLocaleDateString(i18n.language)}
          </div>
          <div>
            {history.createdBy?.name || t("workspace.agent.history.ui.unknown")}
          </div>
        </div>
      </div>
      {history.versionNote && (
        <div
          data-testid="agent-history-version-note"
          className="text-xs text-muted-foreground max-w-[250px] whitespace-pre-wrap break-words"
        >
          {history.versionNote}
        </div>
      )}
    </div>
  )
}
